import * as React from 'react'
import styled from '@theme/styled-components'

import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
  useNavigate,
  useMatch,
  useLocation,
  useSearchParams,
} from 'react-router-dom'

import Screens from './Screens'
import Menu from './Menu'
import MiniMenu from './MiniMenu'
import { View } from 'react-native'
import Login from '@screens/login/login.web'
import useBreakPoints from './breakpoint'

import useReducer from '@store/useReducer'
import * as authStore from '@store/auth/auth'
import { enhanceNavigator } from '@layout/useNavigation'

const ScreenAdapter = ({ screen }: { screen: ScreenDefinition }) => {
  const nav = useNavigate()
  const navigator = enhanceNavigator(nav)

  const location = useLocation()
  const match = useMatch({ path: screen.path })
  const [search] = useSearchParams()

  const matchParams = match?.params || {}
  const params = location.state || {}

  const query = Object.fromEntries(search)

  return <screen.screen navigation={navigator} screen={screen.name} {...params} {...matchParams} {...query} />
}

const NotFound = ({ path }: { path: string }) => {
  return <Navigate replace to={path} />
}

const MainLayout = () => {
  const isConnected = useReducer(authStore.store, s => s.logged)
  const [breakPoint] = useBreakPoints()

  return (
    <Router>
      {isConnected ? (
        <MainContainer>
          {breakPoint >= 800 ? <Menu /> : <MiniMenu />}
          <ScreenContainer>
            <Routes>
              {Object.keys(Screens)
                .filter(k => !Screens[k].platform || Screens[k].platform === 'web')
                .map(k => {
                  const scr = Screens[k]
                  return <Route path={scr.path} key={scr.name} element={<ScreenAdapter screen={scr} />} />
                })}
              <Route path="*" element={<NotFound path="/" />} />
            </Routes>
          </ScreenContainer>
        </MainContainer>
      ) : (
        <MainContainer>
          <ScreenContainer>
            <Routes>
              <Route path="/login" element={<Login />} />
              <Route path="*" element={<NotFound path="/login" />} />
            </Routes>
          </ScreenContainer>
        </MainContainer>
      )}
    </Router>
  )
}

export default MainLayout

const MainContainer = styled(View)`
  flex: 1;
  flex-direction: row;
  background-color: ${props => props.theme.colors.background};
`

const ScreenContainer = styled(View)`
  flex: 1;
`
